var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-container" },
    [
      _c(
        "b-card",
        { staticClass: "sales-chart" },
        [
          _c(
            "b-card-header",
            [_c("b-card-title", [_vm._v("Quantity of Sales Over Time")])],
            1
          ),
          _c("apexcharts", {
            ref: "chart",
            attrs: {
              height: "350",
              type: "line",
              options: _vm.chartOptions,
              series: _vm.filteredChartData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }